<template>
  <validation-observer
    #default="{ handleSubmit }"
    ref="ministryForm"
  >
    <form
      @submit.prevent="
        handleSubmit(onCreateOrUpdate)
      "
    >
      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="Member Type"
            rules="required"
          >
            <b-form-group label="Member Type" label-for="member_type">
              <template #label>
                <span>Member Type<sup style="color: tomato">*</sup></span>
              </template>

              <v-select
                id="member_type"
                v-model="memberProfile.member_type_id"
                placeholder="Member type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="memberTypeOptions"
                :reduce="(val) => val.value"
                :disabled="loading"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="Member Title"
            rules="required"
          >
            <b-form-group label="Member Title" label-for="member_title">
              <template #label>
                <span>Member Title<sup style="color: tomato">*</sup></span>
              </template>

              <v-select
                class="member_title"
                placeholder="Member Title"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :value="memberProfile.member_title_id"
                :options="memberTitleOptions"
                :reduce="(val) => val.value"
                :disabled="loading"
                @input="(val) => (memberProfile.member_title_id = val)"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <b-form-group
            label="Member Designation"
            label-for="member_designation"
          >
            <template #label>
              <span>Member Designation<sup style="color: tomato">*</sup></span>
            </template>

            <validation-provider
              #default="{ errors }"
              name="Member Designation"
              rules="required"
            >
              <v-select
                v-model="memberProfile.member_designation_id"
                class=""
                placeholder="Member Designation"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="memberDesignationOptions"
                :reduce="(val) => val.value"
                :disabled="loading"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Department" label-for="department">
            <template #label>
              <span>Department<sup style="color: tomato">*</sup></span>
            </template>

            <validation-provider
              #default="{ errors }"
              name="Department"
            >
              <v-select
                v-model="memberProfile.department_id"
                class=""
                placeholder="Department"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="departmentOptions"
                :reduce="(val) => val.value"
                :disabled="loading"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <div v-if="country === 'Ghana'">
        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <b-form-group label="Region" label-for="region">
              <template #label>
                <span>Region<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Region"
                rules="required"
              >
                <v-select
                  id="region"
                  v-model="memberProfile.region_id"
                  placeholder="Region"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="regionOptions"
                  :reduce="(val) => val.value"
                  :disabled="loading"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group label="Area" label-for="area">
              <template #label>
                <span>Area<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Area"
                rules="required"
              >
                <v-select
                  id="area"
                  v-model="memberProfile.area_id"
                  placeholder="Area"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="areaOptions"
                  :reduce="(val) => val.value"
                  :disabled="loading"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <b-form-group label="District" label-for="district">
              <template #label>
                <span>District<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="District"
                rules="required"
              >
                <v-select
                  id="district"
                  v-model="memberProfile.district_id"
                  placeholder="District"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="districtOptions"
                  :reduce="(val) => val.value"
                  :disabled="loading"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group label="Assembly" label-for="assembly">
              <template #label>
                <span>Assembly</span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Assembly"
              >
                <v-select
                  id="assembly"
                  v-model="memberProfile.assembly_id"
                  placeholder="Assembly"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="assemblyOptions"
                  :reduce="(val) => val.value"
                  :disabled="loading"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div v-else>
        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              name="Region"
              rules="required"
            >
              <b-form-group label="Region" label-for="region">
                <template #label>
                  <span>Region<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-input
                  id="region"
                  v-model="memberProfile.region"
                  placeholder="Region"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group label="Area" label-for="area">
              <template #label>
                <span>Area<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Area"
                rules="required"
              >
                <b-form-input
                  id="area"
                  v-model="memberProfile.area"
                  placeholder="Area"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <b-form-group label="District" label-for="district">
              <template #label>
                <span>District<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="District"
                rules="required"
              >
                <b-form-input
                  id="district"
                  v-model="memberProfile.district"
                  placeholder="District"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group label="Assembly" label-for="assembly">
              <template #label>
                <span>Assembly<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Assembly"
                rules="required"
              >
                <b-form-input
                  id="assembly"
                  v-model="memberProfile.assembly"
                  placeholder="Assembly"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div v-if="isCopMinister">
        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              name="Minister Id"
              rules="required"
            >
              <b-form-group label="Minister Id" label-for="minister_id">
                <template #label>
                  <span>Minister Id<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-input
                  id="minister_id"
                  v-model="memberProfile.minister_id"
                  placeholder="Minister Id"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              name="Year Called Into Ministry"
              rules="required"
            >
              <b-form-group label="Year Called Into Ministry" label-for="area">
                <template #label>
                  <span>Year Called Into Ministry<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-input
                  id="year_called_into_ministry"
                  v-model="memberProfile.year_called_into_ministry"
                  placeholder="Year called into ministry"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        
        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              name="Date of Engagement"
            >
              <b-form-group label="Date of Engagement" label-for="date_of_engagement">
                <template #label>
                  <span>Date of Engagement</span>
                </template>

                <b-form-datepicker
                  id="date_of_engagement"
                  v-model="memberProfile.date_of_engagement"
                  placeholder="Select date of engagement"
                  :disabled="disableForm"
                  :max="new Date()"
                  locale="en"
                  date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </div>

      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="Called From"
            rules=""
          >
            <b-form-group label="Called From" label-for="called_from">
              <template #label>
                <span>Called From</span>
              </template>

              <b-form-input
                id="called_from"
                v-model="memberProfile.called_from"
                placeholder="Called from"
                :disabled="disableForm"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="Years in Current Area"
            rules=""
          >
            <b-form-group
              label="Years in Current Area"
              label-for="years_in_current_area"
            >
              <template #label>
                <span>Years in Current Area</span>
              </template>

              <b-form-input
                id="years_in_current_area"
                v-model="memberProfile.years_in_current_area"
                placeholder="Years in current area"
                type="number"
                :disabled="disableForm"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="Years in Current Station"
            rules=""
          >
            <b-form-group
              label="Years in Current Station"
              label-for="years_in_current_station"
            >
              <template #label>
                <span>Years in Current Station</span>
              </template>

              <b-form-input
                id="years_in_current_station"
                v-model="memberProfile.years_in_current_station"
                placeholder="Years in current station"
                type="number"
                :disabled="disableForm"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Member Status" label-for="member_status">
            <validation-provider
              #default="{ errors }"
              name="Member Status"
              rules=""
            >
              <v-select
                v-model="memberProfile.member_status_id"
                placeholder="Member Status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="memberStatusOptions"
                :reduce="(val) => val.value"
                :disabled="loading"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider name="Is Tent Minister" rules="">
            <b-form-checkbox
              v-model="memberProfile.is_tent_minister"
              class="mb-3 mt-1"
            >
              Is Tent Minister
            </b-form-checkbox>
          </validation-provider>
        </b-col>
      </b-row>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        size="lg"
        class="mr-2 mb-5"
        :disabled="disableForm"
        type="submit"
      >
        Save
      </b-button>
    </form>
  </validation-observer>
</template>

<script>
import { get } from "lodash";
import Cleave from "vue-cleave-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BOverlay,
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAvatar,
  BFormTextarea,
  BFormInvalidFeedback,
  BButton,
  BFormFile,
  BFormCheckbox,
  BAlert,
  BCardText,
  BModal,
  BMedia,
  BMediaBody,
  BMediaAside,
  BImg,
  BTabs,
  BTab,
  BCard,
  BFormDatepicker,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

const memberTitlesAndDesignationCachedData = [];

export default {
  name: "MinistryUpdate",
  components: {
    vSelect,
    Cleave,
    BOverlay,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAvatar,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton,
    BFormFile,
    BFormCheckbox,
    BAlert,
    BCardText,
    BModal,
    BMedia,
    BMediaBody,
    BMediaAside,
    BImg,
    BTabs,
    BTab,
    BCard,
    BFormDatepicker,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    disableForm: {
      type: Boolean,
      default: false,
    },
    countryOptions: {
      type: Array,
      default: () => [],
    },
    memberStatusOptions: {
      type: Array,
      default: () => [],
    },
    memberTypeOptions: {
      type: Array,
      default: () => [],
    },
    country: {
      type: String,
      default: "",
    },
    departmentOptions: {
      type: Array,
      default: () => [],
    },
    isCopMinister: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      memberProfile: {
        department_id: "",
        member_type_id: "",
        member_title_id: "",
        member_designation_id: "",
        
        region_id: "",
        area_id: "",
        district_id: "",
        assembly_id: "",
        
        called_from: "",
        member_status_id: "",
        years_in_current_area: 0,
        years_in_current_station: 0,
        is_tent_minister: false
      },
      cleaveDateOptions: {
        date: true,
        raw: true,
        delimiter: "-",
        datePattern: ["Y", "m", "d"],
        blocks: [4, 2, 2],
      },
      regionOptions: [],
      areaOptions: [],
      districtOptions: [],
      assemblyOptions: [],
      memberDesignationOptions: [],
      memberTitleOptions: [],
    };
  },
  watch: {
    "memberProfile.member_type_id": {
      handler(member_type_id) {
        this.fetchMemberTitlesAndDesignations(member_type_id);
      }
    },
    "memberProfile.region_id": {
      handler(changed) {
        if (changed) {
          if (changed !== this.initialValues.region_id) {
            this.memberProfile.area_id = "";
            this.memberProfile.district_id = "";
            this.memberProfile.assembly_id = "";
          }
          this.fetchChurchAreas();
        }
      },
      immediate: true,
    },
    "memberProfile.area_id": {
      handler(changed) {
        if (changed) {
          if (changed !== this.initialValues.area_id) {
            this.memberProfile.district_id = "";
            this.memberProfile.assembly_id = "";
          }
          this.fetchChurchDistrict();
        }
      },
      immediate: true,
    },
    "memberProfile.district_id": {
      handler(changed) {
        if (changed) {
          if (changed !== this.initialValues.district_id) {
            this.memberProfile.assembly_id = "";
          }
          this.fetchChurchAssemblies();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.memberProfile = { ...this.initialValues };
    console.log(this.memberProfile);
    this.fetchChurchRegions();
  },
  methods: {
    async onCreateOrUpdate() {
      try {
        const success = await this.$refs.ministryForm.validate();
        if (!success) {
          this.toast({
            title: "Error!",
            icon: "AlertQuestionIcon",
            variant: "warning",
            text: `Member updated successfully`,
          });
          return;
        }
        this.loading = true;
        this.errorMessage = "";

        const messages = {
          update: {
            title: "Confirm Member Update",
            text: "Do you want to update this member?",
            icon: "warning",
          },
        };

        /* eslint-disable no-nested-ternary */
        const message = messages.update;
        const { title, text, icon } = message;

        const result = await this.$swal({
          title,
          text,
          icon,
          showCancelButton: true,
          confirmButtonText: "Yes, proceed.",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });
        if (!result.isConfirmed) {
          return;
        }

        this.sanitizeObjectIds(this.memberProfile);

        await this.useJwt().mainService.memberProfiles.updateMinistry(
          this.$route.params.id,
          this.memberProfile
        );

        this.$emit("refetchData");
        this.$emit("update:is-add-or-update-active", false);

        this.toast({
          title: "Success!",
          icon: "CheckCircleIcon",
          variant: "success",
          text: `Ministry updated successfully`,
        });
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        this.errorMessage = error_message;

        this.toast({
          title: "Error!",
          icon: "AlertQuestionIcon",
          variant: "error",
          text: `Ministry updated failed`,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchRegions() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoRegions();
        const { data } = request.data;
        this.regionOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAreas() {
      try {
        this.loading = true;

        const { region_id } = this.memberProfile;

        if (!region_id) {
          return;
        }
        const request = await this.useJwt().sharedService.fetchGeoAreas({
          region_id,
        });
        const { data } = request.data;
        this.areaOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchDistrict() {
      try {
        this.loading = true;

        const { area_id } = this.memberProfile;
        if (!area_id) {
          return;
        }

        const request = await this.useJwt().sharedService.fetchGeoDistricts({
          area_id,
        });
        const { data } = request.data;
        this.districtOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAssemblies() {
      try {
        this.loading = true;

        if (!this.memberProfile.district_id) {
          return;
        }

        const request = await this.useJwt().sharedService.fetchGeoAssemblies({
          district_id: this.memberProfile.district_id,
        });
        const { data } = request.data;
        this.assemblyOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberTitlesAndDesignations(member_type_id) {
      try {
        const query = {
          member_type_id,
        };
        const member_title_resp =
          await this.useJwt().mainService.memberTitles.list(query);
        const member_designation_rep =
          await this.useJwt().mainService.memberDesignations.list(query);
        const member_titles = get(
          member_title_resp.data,
          "data.[0].categories"
        );
        const member_designations = get(
          member_designation_rep.data,
          "data.[0].categories"
        );

        this.memberTitleOptions = (member_titles || []).map((member_title) => ({
          label: member_title.title,
          value: member_title._id,
        }));

        this.memberDesignationOptions = (member_designations || []).map(
          (member_designation) => ({
            label: member_designation.designation,
            value: member_designation._id,
          })
        );

        memberTitlesAndDesignationCachedData.push({
          id: this.memberProfile.member_type_id,
          titles: this.memberTitleOptions,
          designations: this.memberDesignationOptions,
        });
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      }
    },
  },
};
</script>

<style></style>
